import { useHistory } from "react-router-dom";
import { School, User } from "../../../generated/graphql";
import { Table } from "@material-ui/core";
import { Menu } from "../../shared/Menu";
import {
  SchoolTableHeadCell,
  SchoolTableCell,
  SchoolTableRow,
  WithoutSchoolTableRow,
} from "./SchoolsTable.style";
import { SchoolPaths } from "../../shared/constants";
import { SchoolAdminResolver } from "../../shared/Utils/OtherOperations/schoolAdminResolver";
import { secondary } from "../../shared/Style/Style";

const TABLE_HEADER = [
  "ID",
  "Название",
  "Электронная почта",
  "Номер телефона",
  "Администратор",
  "Ответственный менеджер",
  "",
];

interface SchoolsTableProps {
  schools: School[];
  isPersonal: boolean;
  setSchoolIdToDelete(id: string): void;
  openModal(): void;
}

const schoolAdminData = (admins: User[]) => {
  return SchoolAdminResolver.getDataForSchools(admins).map((d, i) => <p key={i}>{d}</p>);
}

export const SchoolsTable = ({
  schools = [],
  isPersonal,
  setSchoolIdToDelete,
  openModal
}: SchoolsTableProps) => {
  const { push } = useHistory();

  const getSchoolRoute = (id: string) => !isPersonal
    ? `/${SchoolPaths.school}/${id}/edit`
    : `/${SchoolPaths.personal}/${id}/edit`;

  const menuItem = (id: string) => [
    {
      name: "Редактировать",
      action: (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        push(getSchoolRoute(id));
      },
    },
    {
      name: "Удалить",
      action: (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        //TODO: until backend is ready
        // setSchoolIdToDelete(id);
        // openModal();
      },
      color: secondary,
    },
  ];

  return (
    <Table>
      <thead>
        <SchoolTableRow>
          {TABLE_HEADER.map((el, i) => <SchoolTableHeadCell key={i}>{el}</SchoolTableHeadCell>)}
        </SchoolTableRow>
      </thead>
      <tbody>
        {schools.length > 0 ? (schools.map(
          ({ id, idShort, name, phone, email, manager, admins }) => (
            <SchoolTableRow
              key={id}
              onClick={() => push(getSchoolRoute(id))}
            >
              <SchoolTableCell>{idShort}</SchoolTableCell>
              <SchoolTableCell>{name}</SchoolTableCell>
              <SchoolTableCell>{email}</SchoolTableCell>
              <SchoolTableCell>{phone}</SchoolTableCell>
              <SchoolTableCell>{schoolAdminData(admins)}</SchoolTableCell>
              <SchoolTableCell>{manager?.firstName} {manager?.lastName}</SchoolTableCell>
              <SchoolTableCell>
                <Menu
                  vertical={36}
                  horizontal={12}
                  width={170}
                  items={menuItem(id)}
                />
              </SchoolTableCell>
            </SchoolTableRow>
          )
        )) : (
          <WithoutSchoolTableRow>
            <SchoolTableCell>Список школ пуст</SchoolTableCell>
          </WithoutSchoolTableRow>
        )}
      </tbody>
    </Table>
  );
};
